import { DatosContacto, DatosContactoForm, DatosContactoUpsert } from '@models/.';

export function transformToData(contactDetail: DatosContacto | null): DatosContacto | null {
  if (!contactDetail) return null;
  
  return {
    ...contactDetail,
  };
}

export function transformToForm(contactDetail: DatosContacto): DatosContactoForm {
  const {
    idContacto: id,
    nombre: name,
    telefono: phone,
    cargo: position,
    email,
  } = contactDetail;
  
  return {
    id,
    name,
    phone,
    position,
    email,
  };
}

export function transformToUpsert(
  contactDetailForm: DatosContactoForm
): DatosContactoUpsert {
  const {
    name: nombre,
    phone: telefono,
    email,
    position: cargo,
  } = contactDetailForm;

  return {
    nombre: nombre ?? "",
    telefono: telefono ?? "",
    email: email ?? "",
    cargo: cargo ?? "",
  };
}